// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1VjXc","modalForm":"UpgradeEpcsModal_modalForm__jkr2V","modalFooter":"UpgradeEpcsModal_modalFooter__3U1IH"};